module.exports = __webpack_public_path__ + "img/7_40.2e4597e5.png";